import { RegistrationFormData } from "@/interfaces/RegistrationFormData";
import { ContactFormData } from "@/interfaces/ContactFormData";

const apiKey = import.meta.env.VITE_BREVO_API_KEY;

const brevoApiBaseUrl = 'https://api.brevo.com/v3';

// TODO: Move Brevo client creation to separate plugin

const sendEmail = async ({ subject, htmlContent }: { subject: string, htmlContent: string }) => {
  try {
    const response = await fetch(`${brevoApiBaseUrl}/smtp/email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Api-Key': apiKey,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        sender: {
          name: 'Liga Riviera Flag',
          email: 'contact@ligarivieraflag.com'
        },
        to: [
          {
            email: 'alan@letitsite.com',
            name: 'Alan Orozco'
          },
          {
            email: 'miguel@letitsite.com',
            name: 'Miguel Guizar'
          }
        ],
        subject,
        htmlContent,
      })
    });

    if (!response.ok) {
      const message = `Error sending email: ${response.status}`;
      throw new Error(message);
    }

    const data = await response.json();

    console.info('Email sent successfully', data);

  } catch (error) {
    console.error('Error sending email', error);
  }
}

export const sendRegistrationEmail = ({subject, title, formData}: {subject: string, title: string, 
  formData: RegistrationFormData}) => {

    let htmlContent = `<html><head></head><body>
        <h1>${title}</h1>
        <p>Name: ${formData.nombre}</p>
        <p>Email: ${formData.email}</p>
        <p>Team Name: ${formData.nombreEquipo}</p>
        <p>Categories of Interest: ${formData.categoriasInteresadas.join(', ')}</p>
        <p>Phone Number: ${formData.numeroTelefonico}</p>
      </body></html>`;

      sendEmail({ subject, htmlContent });
}

export const sendContactEmail = ({subject, title, formData}: {subject: string, title: string, formData: ContactFormData}) => {

  let htmlContent = `<html><head></head><body>
      <h1>${title}</h1>
      <p>Name: ${formData.nombre}</p>
      <p>Email: ${formData.email}</p>
      <p>Phone Number: ${formData.telefono}</p>
      <p>Subject: ${formData.asunto}</p>
      <p>Message: ${formData.mensaje}</p>
    </body></html>`;

    sendEmail({ subject, htmlContent });
}
